import React from 'react';
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';

export default function Toast({ toast, onClose }) {
  if (!toast) return null;

  const icons = {
    success: <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0" />,
    error: <AlertCircle className="w-5 h-5 text-rose-400 shrink-0" />,
    info: <Info className="w-5 h-5 text-gold-400 shrink-0" />
  };

  const bgColors = {
    success: "border-emerald-500/30 bg-emerald-950/80 text-emerald-100",
    error: "border-rose-500/30 bg-rose-950/80 text-rose-100",
    info: "border-gold-500/30 bg-dark-850/95 text-slate-100"
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 max-w-md w-full animate-bounce-in shadow-2xl transition-all">
      <div className={`p-4 rounded-xl border backdrop-blur-xl flex items-start gap-3.5 shadow-2xl ${bgColors[toast.type || 'info']}`}>
        {icons[toast.type || 'info']}
        <div className="flex-1">
          {toast.title && <h4 className="text-sm font-bold tracking-wide">{toast.title}</h4>}
          <p className="text-xs text-slate-300 mt-0.5 leading-relaxed">{toast.message}</p>
        </div>
        <button
          onClick={onClose}
          className="text-slate-400 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
